export default __webpack_public_path__ + "0d0c6fab83b8b1fc8f14ede0ff4788d0.jpg";